// --------------------------------------------------------
// ADDITIONAL EXAMS - AdditionalExams
// --------------------------------------------------------

// --------------------------------------------------------
// GENERAL
// --------------------------------------------------------
import { Autocomplete, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Text } from "../../../../../../components/UI/generalLayout/Layout.styled";
import Exam from "../../../../../../models/core/careLine/Exam";
import { ReactComponent as Trash } from "../../../../../../assets/imgs/trashBin.svg";
import {
  ContainerCardLineSelected,
  InputDate,
  TextArea,
} from "../cardLineSelected/CardLineSelected.styled";
import moment from "moment";
import Colors from "../../../../../../constants/Colors";
import { ExamService } from "../../../../../../core/http/service/ExamService";
// --------------------------------------------------------

// --------------------------------------------------------
// IMPORTS
// --------------------------------------------------------
// --------------------------------------------------------

// --------------------------------------------------------
// ADDITIONAL EXAMS INTERFACE
// --------------------------------------------------------

interface IAdditionalExams {
  additionalExam: any;
  allExams: Exam[];
  onDeleteOption: any;
  setAdditionalResult: any;
  index: number;
  setInvalidDate: any;
}
/**
/**
 * A component that renders a Component description here.
 *
 * @param props The component props.
 * @returns The component JSX.
 */
const AdditionalExams = ({
  allExams,
  additionalExam,
  onDeleteOption,
  setAdditionalResult,
  setInvalidDate,
  index,
}: IAdditionalExams) => {
  // --------------------------------------------------------
  // ADDITIONAL EXAMS PRIVATE DECLARATIONS
  // --------------------------------------------------------
  const [error, setError] = useState("");
  const [examsOption, setExamsOptions] = useState<any[]>([]);
  // --------------------------------------------------------
  const insertElementIntoAdditionalExam = (object: any) => {
    setAdditionalResult((prev: any) => {
      debugger
      const list = [...prev];
      const removedElement = list.splice(index, 1);
      const newObject = { ...removedElement[0], ...object };
      list.splice(index, 0, newObject);
      return list;
    });
  };

  const insertResultIntoAdditionalExam = (result: any) => {
    setAdditionalResult((prev: any) => {
      const list = [...prev];
      const removedElement = list.splice(index, 1);
      const newObject = {
        ...removedElement[0],
        resultado: { ...removedElement[0].resultado, ...result },
      };
      list.splice(index, 0, newObject);
      return list;
    });
  };
  useEffect(() => {
    if (additionalExam.dataColeta.length === 10) {
      const momentDate = moment(additionalExam.dataColeta, "YYYY-MM-DD");
      if (momentDate > moment()) {
        setError("Data da coleta não pode ser superior à hoje!");
        setInvalidDate(true);
      } else {
        setError("");
        setInvalidDate(false);
      }
    }
  }, [additionalExam]);

  const fetchExams = async (event: any, newValue: any | null) => {
    const examService: ExamService = new ExamService();
    const examResponse: any = await examService.getAll(newValue);

    setExamsOptions(examResponse.data.data);
  };

  // --------------------------------------------------------
  // REACT RETURN FUNCTION
  // --------------------------------------------------------
  return (
    <>
      <ContainerCardLineSelected style={{ marginBottom: 10 }}>
        <Text color={Colors.error}>{error}</Text>
        <div
          style={{
            flexDirection: "row",
            display: "flex",
            gap: 10,
            marginBottom: 20,
          }}
        >
          <div>
            <Text>Nome do exame*</Text>
            <Autocomplete
              value={additionalExam.nome}
              autoComplete
              includeInputInList
              filterSelectedOptions
              filterOptions={(x) => x}
              getOptionLabel={(option) => (option.nome ? option.nome : "")}
              noOptionsText="Nenhum exame encontrado"
              onInputChange={(event, newInputValue) => {
                if (newInputValue.length >= 3) {
                  fetchExams(event, newInputValue);
                } else {
                  setExamsOptions([]);
                }
              }}
              onChange={(event, newValue) => {
                insertElementIntoAdditionalExam({ nome: newValue });
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  size={"small"}
                  style={{ backgroundColor: "white" }}
                  label="Selecione o exame"
                />
              )}
              options={examsOption}
              sx={{ width: 250 }}
            />
          </div>

          <div>
            <Text>Tipo de exame*</Text>
            <Autocomplete
              value={additionalExam.tipo}
              onChange={(event: any, newValue: string | null) => {
                insertElementIntoAdditionalExam({ tipo: newValue });
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  size={"small"}
                  style={{ backgroundColor: "white" }}
                  label="Tipo de exame"
                />
              )}
              options={["Numerico", "Texto"]}
              sx={{ width: 170 }}
            />
          </div>
          <div>
            <Text>Data da coleta*</Text>
            <InputDate
              type={"date"}
              max={moment().format("YYYY-MM-DD")}
              style={{ height: 38, paddingRight: 5, paddingLeft: 5 }}
              onChange={(event: any) => {
                insertElementIntoAdditionalExam({
                  dataColeta: event.target.value,
                });
              }}
            />
          </div>
          <div
            style={{
              display: "flex",
              alignSelf: "center",
              marginTop: 50,
              marginLeft: 10,
            }}
          >
            <Trash style={{ cursor: "pointer" }} onClick={onDeleteOption} />
          </div>
        </div>
        {additionalExam.tipo !== "" && (
          <>
            {additionalExam.tipo === "Numerico" ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: 10,
                  marginBottom: 20,
                }}
              >
                <div>
                  <Text bold>
                    Valor numérico <span style={{ color: "red" }}>*</span>
                  </Text>
                  <InputDate
                    type={"number"}
                    maxLength={8}
                    max={999999}
                    onChange={(event: any) => {
                      insertResultIntoAdditionalExam({
                        valor: event.target.value,
                      });
                    }}
                  />
                </div>
                <div>
                  <Text bold>
                    Unidade de Medida <span style={{ color: "red" }}>*</span>
                  </Text>
                  <InputDate
                    onChange={(event: any) => {
                      insertResultIntoAdditionalExam({
                        unidade: event.target.value,
                      });
                    }}
                  />
                </div>
              </div>
            ) : (
              <div style={{ marginBottom: 20 }}>
                <Text bold>
                  Laudo <span style={{ color: "red" }}>*</span>
                </Text>
                <TextArea
                  rows={8}
                  placeholder={"Laudo textual"}
                  onChange={(event: any) => {
                    insertResultIntoAdditionalExam({
                      valor: event.target.value,
                    });
                  }}
                />
              </div>
            )}
          </>
        )}
      </ContainerCardLineSelected>
    </>
  );
  // --------------------------------------------------------
};

export default AdditionalExams;
